import { useTranslation } from 'react-i18next';
import { InstallmentPlanCode } from 'src/services/dcs/bundle';

export const INSTALLMENT_LENGTH = {
  [InstallmentPlanCode.P]: 1,
  [InstallmentPlanCode.IP3]: 3,
  [InstallmentPlanCode.IP6]: 6,
  [InstallmentPlanCode.IP12]: 12,
};

export const getInstallmentMonth = (num: number) => {
  const { t } = useTranslation();
  switch (num) {
    case 1 :
      return t('installment-details.first');
    case 2 :
      return t('installment-details.second');
    case 3 :
      return t('installment-details.third');
    case 4 :
      return t('installment-details.fourth');
    case 5 :
      return t('installment-details.fifth');
    case 6 :
      return t('installment-details.sixth');
    case 7 :
      return t('installment-details.seventh');
    case 8 :
      return t('installment-details.eighth');
    case 9 :
      return t('installment-details.ninth');
    case 10 :
      return t('installment-details.tenth');
    case 11 :
      return t('installment-details.eleventh');
    case 12 :
      return t('installment-details.twelfth');
    case 13 :
      return t('installment-details.thirteenth');
    default:
      return '';
  }
};

export const getInstallmentPlanName = (plan: string) => {
  const { t } = useTranslation();
  switch (plan) {
    case 'P' :
      return t('installment-details.one');
    case 'IP3' :
      return t('installment-details.three');
    case 'IP6' :
      return t('installment-details.six');
    case 'IP12' :
      return t('installment-details.twelve');
    default:
      return t('installment-details.one');
  }
};
